import React from "react";
import { useTranslation } from "react-i18next";
import "./NoDataConstruction.css";

const NoDataConstruction = ({ text, message, className = "", ...props }) => {
    const { t } = useTranslation();

    // Support both 'text' and 'message' props for backwards compatibility
    const displayText = text || message || t('empty.noData');

    return (
        <div className="no-data-construction__message">
            {displayText}
        </div>
    );
};

export default NoDataConstruction;
